import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTheme } from '../contexts/ThemeContext';

export default function ReportPaymentTypePieChart({ paymentTypes }) {
  const { theme } = useTheme();

  const safeList = Array.isArray(paymentTypes) ? paymentTypes : [];
  const series = safeList.map((v) => Number(v?.total || 0));
  const labels = safeList.map((v) => String(v?.title || 'Unknown'));
  const totalSum = series.reduce((a, b) => a + b, 0);

  if (safeList.length === 0 || totalSum === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-xs text-gray-400">
        No payment records found
      </div>
    );
  }

  const options = {
    chart: {
      width: "100%",
      type: 'pie',
      animations: {
        enabled: false,
      },
      redrawOnParentResize: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: [theme === 'light' ? '#fff' : '#1f2937']
    },
    colors: theme === 'light' 
      ? ["#D3EE98", "#73EC8B", "#54C392", "#15B392", "#347928", "#A0D683", "#72BF78"] 
      : ["#5A7A3B", "#256A3F", "#25605B", "#1D4D42", "#284F28", "#4A6B3A", "#3E613F"],
    labels: labels,
    responsive: [{
      options: {
        chart: {
          width: "100%"
        },
        legend: {
          position: 'right'
        }
      }
    }]
  };

  return (
    <div>
      <ReactApexChart options={options} series={series} type="pie" width="100%" />
    </div>
  );
}
